import React, { useMemo } from 'react'
import { Box } from '@usap/uicomponents'
import Avatar from './Avatar'
import { Title } from '../meta'

export default function UserInfoMsg({
  bgColor,
  icon,
  infoType,
  textColor = 'dark-2',
  isMobile,
  infoLocation = '',
}) {
  const infoDataTestId = useMemo(() => {
    if (infoLocation === 'garagePage') {
      if (isMobile) {
        return 'wom-garage-success-msg'
      }

      return 'desktop-garage-success-msg'
    }

    return ''
  }, [infoLocation, isMobile])

  return (
    <Box
      direction="row"
      border={{ color: bgColor, side: 'all' }}
      style={{ borderLeftWidth: '6px' }}
      pad="small"
      margin={{ vertical: 'small' }}
      borderColor={bgColor}
    >
      {icon && <Avatar background={bgColor} Icon={icon} IcoSize="24px" />}
      <Box alignSelf="center" pad={{ left: 'small' }} width="100%">
        <Title
          size="small"
          {...infoDataTestId && { 'data-testid': infoDataTestId }}
          color={textColor}
          dangerouslySetInnerHTML={{ __html: infoType }}
        />
      </Box>
    </Box>
  )
}
